import { createContext } from 'react';

// What the V3 pages share: the colour mode, how to switch it, and whether the light theme is released.
export const V3Context = createContext({ mode: 'light', toggleMode: () => {}, lightEnabled: false });
